// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3799":"4c3eb7b9","4286":"8bd307c2","5034":"7fab04b7","5408":"4c3eb7b9","5720":"4c3eb7b9","6641":"2cfdbae6","7311":"4c3eb7b9"}[chunkId] + ".chunk.css";
};